import React from 'react'
import ResponsiveDrawer from '../../../components/AdminComponents/Admindashboardnav'
import { Outlet, useNavigate } from 'react-router-dom'


export default function AdminDashboard() {
  const nav = useNavigate()
  React.useEffect(()=>{
    if(!localStorage.getItem("token")){
      nav('/')
    }
  }, [])
  return (
  <div>
    <ResponsiveDrawer/>
    <Outlet/>
  </div>
  )
}
